import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Checkbox,
  ListItem,
  ListItemPrefix,
  Typography,
} from "@material-tailwind/react";
import React, { useRef, useState } from "react";
import ConferenceStatusTag from "../components/ConferenceStatusTag";
import DetailItem from "../../../common/shared/DetailItem";
import ConferenceReceiptButton from "../common/ConferenceReceiptButton";
import HotelButton from "../common/HotelButton";
import OpenModal from "../../../common/actions/OpenModal";
import QRCode from "react-qr-code";
import { useDispatch, useSelector } from "react-redux";
import InputArea from "../../../common/forms/InputArea";
import { conferenceNeeds } from "../../../redux/actions/conference_action";
import ReactToPrint from "react-to-print";
import ImageUpload from "../../../common/forms/ImageUpload";
import DetailListItem from "../../../common/shared/DetailListItem";
import * as api from "../../../redux/api/conference/conference_api";
import * as types from "../../../redux/constants/conference_constants";
import toast from "react-hot-toast";
import { openZoomLink } from "../../../utils/zoomOpen";

const items = [
  { id: "air", label: "By Air" },
  { id: "bus", label: "By Bus" },
];

function ConferenceList({ row }) {
  const [code, setQrcode] = useState(false);
  const [needs, setNeeds] = useState(false);
  const [trans, setTrans] = useState(false);
  const [showUpload, setShowUpload] = useState(false);

  const [transport, setTransport] = useState({});
  const [creche, setCreche] = useState({});
  const [services, setServices] = useState({});

  const [transLoading, setTransLoading] = useState(false);

  const [loading, setLoading] = useState(false);

  let cardBodyRef = useRef();

  const userData = useSelector((state) => state.auth?.userData);

  const [formData, setFormData] = useState(row);

  const dispatch = useDispatch();

  const updateFormValue = ({ updateType, value }) => {
    setFormData({ ...formData, [updateType]: value });
  };

  const handleModal = () => {
    setTrans((prev) => !prev);
    localStorage.removeItem("services");

    const data = row[0];
    const savedServices = JSON.parse(localStorage.getItem("services")) || {};

    if (data?.receipt) {
      if (
        data?.transport?.type &&
        data?.transport?.sub_type &&
        !data?.transport?.status
      ) {
        setTransport(data.transport.sub_type);
        savedServices.transport = {
          amount: data.meta.services[data.transport.sub_type],
          type: data.transport.sub_type,
        };
      }

      if (data?.creche?.type && !data?.creche?.status) {
        setCreche(data.creche.type);
        savedServices.creche = {
          amount: data.meta.services["creche"],
          type: "creche",
        };
      }

      if (Object.keys(savedServices).length > 0) {
        localStorage.setItem("services", JSON.stringify(savedServices));
        setServices(savedServices);
      }
    }
  };

  const handleCode = () => setQrcode(!code);
  const handleNeeds = () => setNeeds(!needs);

  const handleNeedsForm = async () => {
    setLoading(true);

    const sendData = {
      conference: formData[0].id,
      foods: formData.foods,
      needs: formData.needs,
      bar_number: userData.bar_number,
    };

    await dispatch(conferenceNeeds(sendData)).finally(() => {
      setLoading(false);
      setNeeds(!needs);
      window.location.reload();
    });
  };

  const handleUploadModal = () => {
    setShowUpload(!showUpload);
  };

  const handleServices = (type, value) => {
    const currentServices = { ...services };

    const isSelected =
      currentServices[type]?.type === value ||
      currentServices[type]?.value === value;

    if (isSelected) {
      delete currentServices[type];

      if (type === "transport") setTransport("");
      if (type === "creche") setCreche("");
    } else {
      if (type === "transport") {
        setTransport(value);
        currentServices.transport = {
          amount: row[0].meta.services[value],
          type: value,
        };
      }

      if (type === "creche") {
        setCreche(value);
        currentServices.creche = {
          amount: row[0].meta.services["creche"],
          type: "creche",
        };
      }
    }

    if (Object.keys(currentServices).length === 0) {
      localStorage.removeItem("services");
    } else {
      localStorage.setItem("services", JSON.stringify(currentServices));
    }

    setServices(currentServices);
  };

  // const handleServices = (type, value) => {
  //   const currentServices = JSON.parse(localStorage.getItem("services")) || {};

  //   const isSelected =
  //     currentServices[type]?.type === value ||
  //     currentServices[type]?.value === value;

  //   if (isSelected) {
  //     delete currentServices[type];

  //     if (type === "transport") setTransport("");
  //     if (type === "creche") setCreche("");
  //   } else {
  //     if (type === "transport") {
  //       setTransport(value);
  //       currentServices.transport = { amount: row[0].meta[value], type: value };
  //     }

  //     if (type === "creche") {
  //       setCreche(value);
  //       currentServices.creche = { amount: row[0].meta[value], type: value };
  //     }
  //   }

  //   if (Object.keys(currentServices).length === 0) {
  //     localStorage.removeItem("services");
  //   } else {
  //     localStorage.setItem("services", JSON.stringify(currentServices));
  //   }

  //   setServices(currentServices);
  // };

  const handleLive = async (e) => {
    e.preventDefault();

    const formData = {
      transport: {
        value: transport ?? "",
        amount: row[0].meta.services[transport],
      },
      creche: {
        value: creche ?? "",
        amount: row[0].meta.services[creche],
      },
      id: row[0].id,
    };
    setTransLoading(true);

    try {
      const response = await api.conferenceTrans(formData);
      const { error } = response;

      if (error) {
        setTransLoading(false);
        setTrans(false);
        toast.error(error);
        dispatch({ type: types.CONFERENCE_TRANS_FAILURE, payload: error });
      } else {
        toast.success("Conference facility added successfully.");
        // window.location.href = data.link;
        setTransLoading(false);
        setTrans(false);
      }
    } catch (error) {
      setTransLoading(false);
      setTrans(false);
    }
  };

  return (
    row &&
    row.map((data) => (
      <div key={data.id} className="card-wrapper">
        {/* {data.receiptStatus === false && ( */}
        {/* {Date.parse(data.meta.pause) > Date.now() && !data.receipt && ( */}
        {/* {!data.standing ? (
          <AlertMessage message="Please be in good financial standing to register for conference." />
        ) : data.bm === null ? (
          <AlertMessage message="Please upload image to register for conference." />
        ) : (
          !data.receipt &&
          data.bm != null &&
          null(<ConferenceRegister item={data} disabled={!data.standing} />)
        )} */}
        {/* {!data.standing ? (
          <AlertMessage message="Please be in good financial standing to register for conference." />
        ) :  */}

        {/* : data.bm === null && !data.receipt ? (
          <AlertMessage message="Please upload your passport picture to complete your profile." />
         ) */}
        {/* 
        !data.receipt ||
          (data.receipt.status === 0 &&
            Date.parse(data.meta.pause) > Date.now()) ? (
          <ConferenceRegister item={data} disabled={!data.standing} />
        ) : 
        
        null} */}

        {/* )} */}

        {/* )} */}
        {/* {data.receiptStatus && data.amount > 0 && !data.receipt ? (
          <ConferencePayment
            data={data}
            // disable={Date.parse(data.meta.pause) < Date.now()}
          />
        ) : null} */}

        {/* {data.receiptStatus === false &&
          Date.parse(data.meta.pause) > Date.now() && (
            <ConferenceRegister item={data} disabled={!data.standing} />
          )} */}
        <Card>
          <CardBody>
            <ConferenceStatusTag data={data} />
            {data.bm == null && Date.parse(data.meta.pause) > Date.now() && (
              <Button
                size="lg"
                color="pink"
                className="my-8"
                onClick={handleUploadModal}
              >
                CLICK HERE TO UPLOAD IMAGE
              </Button>
            )}
            <Typography variant="h5" color="blue-gray" className="mb-4">
              {/* {`${data.name} ${data.conf_type ? " - " + data.conf_type : ""}`} */}
              {`${data.name}`}
            </Typography>
            {data.meta.theme && (
              <DetailItem title="Theme" item={data.meta.theme} />
            )}

            {data.meta.venue && (
              <DetailItem title="Venue" item={data.meta.venue} />
              // <DetailItem
              //   title="Venue"
              //   item={
              //     <>
              //       MORNING: {data.meta.venue} <br /> EVENING:{" "}
              //       {data.meta.evening}
              //     </>
              //   }
              // />
            )}

            <DetailItem
              title="Date"
              item="SUNDAY, 14TH SEPTEMBER, 2025 to FRIDAY, 19TH SEPTEMBER - 9am - 4pm"
            />

            {data.meta.speakers && (
              // <DetailItem title="Keynote Speaker" item={data.meta.speaker} />
              <DetailListItem
                title="Speakers for Conference:"
                items={data.meta.speakers}
              />
            )}

            {data.meta.topics && (
              <DetailListItem
                title="Highlights of the Conference:"
                items={data.meta.topics}
              />
            )}

            {/* <DetailItem title="Amount" item={`GH¢${data.amount.toFixed(2)}`} /> */}
          </CardBody>
          <CardFooter>
            {data.receipt && data.receipt.status === 1 ? (
              <div className="flex flex-col gap-4 md:flex-row md:items-center">
                <ConferenceReceiptButton
                  id={data.receipt.id}
                  link={`/home/conference/receipt/${data.receipt.id}`}
                  disabled={data.receipt.amount === 0 ? true : false}
                />
                <Button color="blue" onClick={() => openZoomLink(data.zoom)}>
                  Conference Virtual Access
                </Button>
                {data.conf_type === "In-Person" && (
                  <>
                    {data.meta.hotels && (
                      <HotelButton link={data.meta.hotels} />
                    )}

                    <Button onClick={handleCode} color="amber">
                      Generate Access Code
                    </Button>

                    <Button onClick={handleNeeds} color="purple">
                      Special Needs / Special Foods
                    </Button>

                    {data.meta.services.air !== "0" && (
                      <Button onClick={handleModal}>
                        Conference Transport / Creche
                      </Button>
                    )}
                  </>
                )}
              </div>
            ) : (
              // ) : data.receiptStatus && data.amount > 0 ? (
              //   <ConferencePayment
              //     data={data}
              //     disable={Date.parse(data.meta.pause) < Date.now()}
              //   />
              ""
            )}
          </CardFooter>
        </Card>
        {code && (
          <OpenModal
            open={code}
            handler={handleCode}
            // title="Conference Code"
            children={
              <>
                <div class="flex justify-center items-center mb-6">
                  <div class="text-center">
                    <ReactToPrint
                      trigger={() => <Button>Print Code</Button>}
                      content={() => cardBodyRef}
                      removeAfterPrint={false}
                    />
                  </div>
                </div>

                <div
                  ref={(el) => (cardBodyRef = el)}
                  style={{
                    height: "auto",
                    margin: "0 auto",
                    maxWidth: 200,
                    width: "100%",
                  }}
                >
                  <QRCode
                    size={256}
                    className="mt-12"
                    style={{
                      height: "auto",
                      maxWidth: "100%",
                      width: "100%",
                    }}
                    value={userData.bar_number}
                    // viewBox={`0 0 256 256`}
                  />
                </div>
              </>
            }
          />
        )}
        {needs && (
          <OpenModal
            open={needs}
            handler={handleNeeds}
            title="Conference Needs"
            actionTitle="Submit"
            handleSubmit={handleNeedsForm}
            loading={loading}
            children={
              <>
                <div className="mb-6">
                  <InputArea
                    defaultValue={data?.needs}
                    updateType="needs"
                    labelTitle="Special Needs"
                    updateFormValue={updateFormValue}
                  />
                </div>
                <InputArea
                  defaultValue={data?.foods}
                  updateType="foods"
                  labelTitle="Food Exemptions"
                  updateFormValue={updateFormValue}
                />
              </>
            }
          />
        )}
        {showUpload && (
          <ImageUpload open={showUpload} handleClose={handleUploadModal} />
          // <OpenModal
          //   open={showUpload}
          //   handler={handleUploadModal}
          //   title="Upload Image"
          //   actionTitle="Submit"
          //   children={
          //     <>
          //       <FileUpload
          //         label="Image"
          //         onUpload={(file) =>
          //           dispatch(upoloadConferenceFace(file, "file"))
          //         }
          //       />
          //     </>
          //   }
          // />
        )}
        {trans && (
          <OpenModal
            open={trans}
            handler={() => handleModal()}
            title="Confirm Participation"
            loading={transLoading}
            actionTitle="Proceed"
            handleSubmit={(e) => handleLive(e)}
            disable={
              (row[0]?.transport?.status && row[0]?.creche?.status) ||
              Object.keys(services).length === 0
            }
            children={
              <div className="flex flex-col gap-4">
                {row[0].receipt.sub_type === "In-Person" && (
                  <>
                    <Typography color="black" className="text-xl">
                      Below are optional services you can subscribe to as part
                      of the conference Participation
                    </Typography>
                    {/* <Typography color="black" className="font-bold">
                      *actual charge to be announced later
                    </Typography> */}
                    <div className="ml-4">
                      <Typography color="black" className="font-bold">
                        {` 1. Transportation ${
                          row[0]?.transport?.status
                            ? ` - PAID - By ${row[0].transport.sub_type}`
                            : ":"
                        }`}
                      </Typography>
                      {!row[0]?.transport?.status && (
                        <div className="flex flex-col ml-8">
                          {items
                            .filter(({ id }) => id !== "air") // Exclude "air" from rendering
                            .map(({ id, label }) => (
                              <ListItem key={id} className="p-0">
                                <label
                                  htmlFor={`vertical-list-${id}`}
                                  className="flex w-full cursor-pointer items-center px-3 py-2"
                                >
                                  <ListItemPrefix className="mr-3">
                                    <Checkbox
                                      id={`vertical-list-${id}`}
                                      checked={transport === id}
                                      onChange={() =>
                                        handleServices("transport", id)
                                      }
                                      ripple={false}
                                      className="hover:before:opacity-0"
                                      containerProps={{
                                        className: "p-0",
                                      }}
                                      disabled={row[0]?.transport?.status}
                                    />
                                  </ListItemPrefix>
                                  <Typography
                                    color="blue-gray"
                                    className="font-medium"
                                  >
                                    {`${label} - ${
                                      row[0].meta.services[id] !== "0"
                                        ? // ? `GHS${row[0].meta.services[id]}`
                                          ""
                                        : ""
                                    }`}
                                  </Typography>
                                </label>
                              </ListItem>
                            ))}
                        </div>
                      )}
                    </div>
                    <div className="ml-4">
                      <ListItem className="p-0">
                        <label
                          htmlFor={`vertical-list-crech`}
                          className="flex w-full cursor-pointer items-center px-3 py-2"
                        >
                          <ListItemPrefix className="mr-3">
                            <Checkbox
                              id={`vertical-list-crech`}
                              checked={creche === "creche"}
                              onChange={() =>
                                handleServices("creche", "creche")
                              }
                              ripple={false}
                              className="hover:before:opacity-0"
                              containerProps={{
                                className: "p-0",
                              }}
                              disabled={row[0]?.creche?.status}
                            />
                          </ListItemPrefix>
                          <Typography color="blue-gray" className="font-bold">
                            {` 2. Creche Facilities - ${
                              row[0]?.creche?.status
                                ? "PAID"
                                : row[0]?.meta?.services?.creche !== "0"
                                ? `GHS${row[0]?.meta?.services?.creche}`
                                : ""
                            }`}
                          </Typography>
                        </label>
                      </ListItem>
                    </div>
                  </>
                )}
              </div>
            }
          />
        )}
      </div>
    ))

    // </div>
  );
}

export default ConferenceList;
